import { useCallback, useEffect, useState } from 'react';
import { sunatApi, TipoDocumento } from '../api/sunat.api';

const FALLBACK: TipoDocumento[] = [
  { codigo: '0', nombre: 'Doc. tributario no domiciliado sin RUC', abreviatura: 'OTRO', maxLength: 15, permiteConsulta: false },
  { codigo: '1', nombre: 'DNI', abreviatura: 'DNI', maxLength: 8, permiteConsulta: true },
  { codigo: '4', nombre: 'Carnet de extranjeria', abreviatura: 'CE', maxLength: 12, permiteConsulta: false },
  { codigo: '6', nombre: 'RUC', abreviatura: 'RUC', maxLength: 11, permiteConsulta: true },
  { codigo: '7', nombre: 'Pasaporte', abreviatura: 'PAS', maxLength: 12, permiteConsulta: false },
];

export const useTiposDocumento = () => {
  const [tipos, setTipos] = useState<TipoDocumento[]>(FALLBACK);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await sunatApi.getTiposDocumento();
      if (Array.isArray(data) && data.length > 0) setTipos(data);
    } catch {
      // Se mantiene el fallback local si la API no responde.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { tipos, loading, reload };
};
